<script setup lang="ts">
import type { WorkspaceSettings } from '../types/workspace';

const props = withDefaults(defineProps<{
  calendar: WorkspaceSettings['calendar'];
  modelValue?: Record<string, string | number | null>;
  readonly?: boolean;
}>(), { modelValue: () => ({}), readonly: false });
const emit = defineEmits<{ 'update:modelValue': [value: Record<string, string | number | null>]; change: [] }>();

function update(key: string, value: string | number | null) {
  emit('update:modelValue', { ...props.modelValue, [key]: value === '' ? null : value });
  emit('change');
}
</script>

<template>
  <label v-for="component in calendar.components" :key="component.key">{{ component.label }}
    <select v-if="component.kind === 'ordered'" :value="modelValue[component.key] ?? ''" :disabled="readonly" @change="update(component.key, ($event.target as HTMLSelectElement).value)"><option value="">–</option><option v-for="value in component.values" :key="value" :value="value">{{ value }}</option></select>
    <input v-else-if="component.kind === 'number'" :value="modelValue[component.key] ?? ''" type="number" :disabled="readonly" placeholder="–" @input="update(component.key, ($event.target as HTMLInputElement).value === '' ? null : Number(($event.target as HTMLInputElement).value))" />
    <input v-else :value="modelValue[component.key] ?? ''" type="text" maxlength="120" :disabled="readonly" placeholder="–" @input="update(component.key, ($event.target as HTMLInputElement).value)" />
  </label>
</template>
